// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rc-0";